
import slide from '../assets/images/slide.jpeg'

export const Menu  = [
    {
        id : 1,
        title: 'home',
        path: '/',
        cname: 'nav-item',
        component : 'Home'
    },
    {
        id : 3,
        title: 'tboard',
        path: '/dashboard',
        cname: 'nav-item',
        component : 'Dashboard'
    }
    ,
    {
        id : 4,
        title: 'sourcenbalance',
        path: '/balance',
        cname: 'nav-item',
        component : 'Balance'
    },
    {
        id : 5,
        title: 'indicator',
        path: '/indicator',
        cname: 'nav-item',
        component : 'Indicateur'
    },
    {
        id : 6,
        title: 'sankey',
        path: '/sankey',
        cname: 'nav-item',
        component : 'Stats'
    },
    {
        id : 7,
        title: 'sig',
        path: '/sig',
        cname: 'nav-item',
        component : 'Sig'
    },
    {
        id : 8,
        title: 'map',
        path: '/map',
        cname: 'nav-item',
        component : 'Map'
    }
]

export const Auth = {
    id:1,
    title: 'login',
    path: '/signin',
    cname: 'nav-item',
    component: 'Signin'
}



export const SlideContent = {
    id:1,
    name: 'slide 1',
    image: slide,
}
